import { AnimateDiv } from '@/components/Common/AnimateDiv';
import { HomeStepIcon } from '@/components/icon';
import { Group, Stack, Title, Text, Card } from '@mantine/core';

export const CustomerExperience = () => {
  const steps = [
    {
      title: 'STEP.01',
      description: 'ボットの名前・役割を入力',
      image: '/home/step1.png',
    },
    {
      title: 'STEP.02',
      description: 'ファイル・URL等をアップロード',
      image: '/home/step2.png',
    },
    {
      title: 'STEP.03',
      description: 'ウェブサイトに埋め込み',
      image: '/home/step3.png',
    },
  ];

  return (
    <section className="flex flex-col mt-40 max-w-[1520px] mx-auto px-[20px] lg:px-[80px]">
      <AnimateDiv>
        <Group gap="lg" wrap="nowrap">
          <img src="/home/planet.png" alt="" className="w-24 lg:w-32 h-24 lg:h-32" />
          <Title order={2} className="text-xl md:text-2xl lg:text-4xl xl:text-5xl font-bold">
            顧客体験を変えるAIチャットボットの導入
          </Title>
        </Group>
      </AnimateDiv>

      <AnimateDiv>
        <Group className="mt-16" wrap="nowrap" justify="space-between">
          <Stack gap="lg">
            <Title order={3} className="text-xl lg:text-4xl xl:text-5xl font-bold">
              構築はわずか3ステップ
            </Title>
            <Text c="dimmed" className="text-base lg:text-2xl">
              GBase Supportは、タグ付けや定期更新なしでファイルやWebサイトをAIナレッジベースに変換。
              <br />
              Agentic RAG技術により、高速かつスケーラブルな専用ナレッジベースを実現します。
            </Text>
          </Stack>
          <img src="/home/wheel.png" alt="" className="w-28 lg:w-60 h-28 lg:h-60" />
        </Group>
      </AnimateDiv>

      <AnimateDiv>
        <Card
          withBorder
          radius="md"
          bg="gray.0"
          className="border-[#EBEBEB] mt-4 py-6 lg:py-10 px-4 lg:px-8 lg:flex-nowrap"
        >
          <Title order={4} className="text-xl lg:text-3xl font-bold">
            構築は簡単3ステップ
          </Title>
          <Text c="dimmed" className="text-base lg:text-2xl">
            登録するだけで、すぐに導入完了。技術的な設定は不要です。
          </Text>
          <Group className="mt-8 flex-col lg:flex-row lg:flex-nowrap" gap="xl">
            {steps.map((step) => (
              <Stack key={step.title} gap="sm">
                <Group wrap="nowrap" gap="sm">
                  <Text className="text-sm lg:text-lg font-bold bg-violet-500 text-white px-3 rounded-full">
                    {step.title}
                  </Text>
                  <Text className="text-sm lg:text-lg font-bold">{step.description}</Text>
                </Group>
                <img src={step.image} alt={step.title} className="w-full" />
              </Stack>
            ))}
          </Group>
          <div className="mx-auto hidden lg:block">
            <HomeStepIcon />
          </div>
          <img src="/home/step-end.png" alt="" className="mx-0 lg:mx-16 mt-8 lg:mt-0" />
        </Card>
      </AnimateDiv>

      <Group align="stretch" className="mt-10 flex-col lg:flex-row lg:flex-nowrap">
        <AnimateDiv className="border border-[#EBEBEB] rounded-md !bg-[#F8F7FF]/80 py-6 lg:py-10 px-0 w-full lg:w-1/2">
          <Title order={5} className="text-base lg:text-2xl font-bold px-4 lg:px-8">
            日々更新されるWebサイトの再学習も簡単
          </Title>
          <Text c="dimmed" className="text-sm lg:text-xl px-4 lg:px-8 mt-2">
            自動更新と再訓練で、常に最新のコンテンツを維持します。
          </Text>
          <AnimateDiv delay={0.4} className="mr-16 mt-8">
            <img src="/home/result1.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>

        <AnimateDiv className="border border-[#EBEBEB] rounded-md !bg-gray-50 py-6 lg:py-10 px-0 w-full lg:w-1/2">
          <Title order={5} className="text-base lg:text-2xl font-bold px-4 lg:px-8">
            導入効果の確認はダッシュボードで
          </Title>
          <Text c="dimmed" className="text-sm lg:text-xl px-4 lg:px-8 mt-2">
            使いやすいダッシュボードで管理・監視・チューニングが可能です。
          </Text>
          <AnimateDiv delay={0.4} className="mx-8 lg:mx-12 mt-6">
            <img src="/home/result2.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>
      </Group>
    </section>
  );
};
